module.exports = __webpack_public_path__ + "img/online_shop.146c587b.png";